export const POLL_UI_STATE = {
  NORMAL: 'normal',
  ALERT_LEVEL_1: 'alert_level_1',
  ALERT_LEVEL_2: 'alert_level_2',
  BLOCKED_LEVEL_3: 'blocked_level_3',
  UNLOCK_SUCCESS: 'unlock_success',
} as const;

export type PollUiState =
  (typeof POLL_UI_STATE)[keyof typeof POLL_UI_STATE];
